"use client";
import cn from "classnames";
import { usePathname } from "next/navigation";
import { type ReactNode, useCallback, useEffect, useState } from "react";
import BurgerIcon from "../../BurgerIcon";
import s from "./MobileNavToggle.module.scss";

export interface MobileNavToggleProps {
  menu: ReactNode;
  footer: ReactNode;
}

export default function MobileNavToggle(props: MobileNavToggleProps) {
  const { menu, footer } = props;
  const pathname = usePathname();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const handleOpen = useCallback(() => {
    setOpen((o) => !o);
  }, []);

  return (
    <>
      <BurgerIcon open={open} onClick={handleOpen} />
      <nav
        className={cn(s.nav, {
          [s.open]: open,
          ["informa-mobile-nav-modal-open"]: open,
        })}
      >
        <div className={s.menu}>{menu}</div>
        <div className={s.footer}>{footer}</div>
      </nav>
    </>
  );
}
